import {UI} from "../../../../stem-core/ui/UIBase";
import {ActiveSubscriptions} from "./sections/ActiveSubscriptions.jsx";
import {SubscriptionPayments} from "./sections/SubscriptionPayments.jsx";
import {PastSubscriptions} from "./sections/PastSubscriptions.jsx";
import {Subscription} from "../../../State.js";
import {Dispatcher} from "../../../../stem-core/base/Dispatcher";
import {getQueryParam} from "../../../UtilsLib.js";
import {userService} from "../../../../client/connection/services/UserService.js";
import {autoredraw} from "../../../../stem-core/decorators/AutoRedraw";


@autoredraw(Subscription)
export class SubscriptionsPage extends UI.Element {
    render() {
        return [
            <ActiveSubscriptions testId="activeSubscriptionsCard"/>,
            (Subscription.getPast().length > 0) && <PastSubscriptions testId="pastSubscriptionsCard"/>,
            <SubscriptionPayments testId="subscriptionPaymentsCard"/>,
        ];
    }

    onMount() {
        // TODO @cleanup what is this crap?
        const dispatchEntryFocus = () => {
            userService.ensureUserDataRequested(() => {
                const subscriptionFocusId = getQueryParam("focus");
                if (subscriptionFocusId) {
                    const subscription = Subscription.get(subscriptionFocusId);
                    Dispatcher.Global.dispatch("highlightEntry", subscription);
                }
            })
        };
        this.attachTimeout(dispatchEntryFocus);
        this.addListener("urlEnter", dispatchEntryFocus);
    }
}
